/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useLookupCashCenters } from "../../services/lookups-mutations";
import ReactHookFormDropdown from "../../components/forms/react-hook-dropdown";
import FormInput from "../../components/forms/form-Input";
import {
  useEditConsumables,
  useGetConsumable,
} from "../../services/consumables";

export default function EditConsumable() {
  const [consumable, setConsumable] = useState(null);
  const navigate = useNavigate();
  const params = useParams();

  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
    // error: cashCenterListError,
  } = useLookupCashCenters();

  const {
    mutate: createRequest,
    data: createRequestResponse,
    isPending: creatingRequest,
    error: createError,
  } = useEditConsumables();
  const {
    mutate: getDetails,
    data: detailsRes,
    isPending: gettingDetails,
    // error: detailsError,
    reset: detailsReset,
  } = useGetConsumable();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  useEffect(() => {
    getCashCenter();

    if (params.consumableId) {
      getDetails(params.consumableId);
    }
  }, []);
  useEffect(() => {
    if (createRequestResponse) {
      navigate(Paths.consumable);
    }
    if (detailsRes) {
      const _res = detailsRes.data;
      setConsumable({ ..._res });
      const _details = {
        ..._res,
        cashCenterId: _res.cashCenterId
          ? { cashCenterId: _res.cashCenterId, name: _res.cashCenter }
          : "",
        status: _res.status ? _res.status : "",
      };
      reset({ ..._details });
      detailsReset();
    }
  }, [createRequestResponse, createError, detailsRes, cashCenterList]);

  const formValidationRules = {
    cashCenterId: { required: "Please select cash center" },
    status: { required: "Please select status" },
    sealNo: { required: "Please add seal no" },
    description: { required: "Please add description" },
  };
  const generalFieldProps = { errors, control };

  const onSubmit = (data) => {
    const _payload = {
      id: consumable.id || consumable.consumableId,
      cashCenterId: data.cashCenterId || "",
      sealNo: data.sealNo,
      status: data.status,
      description: data.description,
    };
    // console.log(_payload);
    createRequest(_payload);
  };
  return (
    <>
      {gettingCashCenterList || gettingDetails || creatingRequest ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Consumables", link: Paths.consumable },
            { text: "Edit Consumable", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Heading>Edit Consumable</Heading>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="add-location-form"
              >
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Cash Center"
                  name="cashCenter"
                  data={cashCenterList?.data.map(item => ({ value: item.cashCenterId, label: item.name })) || []}
                  placeholder="Select Cash Center"
                  rules={formValidationRules.cashCenterId}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Description"
                  name="description"
                  rules={formValidationRules.description}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Seal No"
                  name="sealNo"
                  rules={formValidationRules.sealNo}
                />
                <ReactHookFormDropdown
                  {...generalFieldProps}
                  isRequired
                  label="Status"
                  name="status"
                  data={[
                    { value: "In Stock", label: "In Stock" },
                    { value: "Used", label: "Used" },
                  ]}
                  placeholder="Select Status"
                  rules={formValidationRules.status}
                />

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "16px",
                  }}
                >
                  <Button type="submit">Update Consumable</Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
